import { apiCall } from "./Interceptor";

const POINT_DRAWL_ALL = "/point/getAll/public";

const getAllpoint = async () => {
    const response = await apiCall.get(POINT_DRAWL_ALL);
    return response;
}

export default {
    getAllpoint,
};
